import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import Breadcrumbs from '../components/common/Breadcrumbs';
import OrgBlock from '../components/common/OrgBlock';
import Icon from '../components/common/Icon';

const EventoPage = () => {
  return (
    <Layout>
      <div className="container"><Breadcrumbs items={[{ label: 'Home', path: '/' }, { label: 'Eventi', path: '/eventi' }, { label: 'Forum Nazionale' }]} style={{ paddingTop: 'var(--space-6)' }} /></div>
      <section className="hero hero--dark" style={{ minHeight: 450, position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1 }}>
          <img src="https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=1600&auto=format&fit=crop" alt="Forum Background" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.4 }} />
        </div>
        <div className="container"><div className="hero__content">
        <div className="hero__overline">22 Marzo 2026</div>
        <h1 className="text-hero hero__title">Forum Nazionale<br />Giovani e Lavoro</h1>
        <p className="hero__subtitle">Una giornata di confronto e proposte per il mondo del lavoro giovanile.</p>
        <div className="btn-group mt-6"><button className="btn btn--white"><Icon name="CalendarPlus" size={16} style={{ marginRight: 6 }} /> Aggiungi al calendario</button><button className="btn btn--outline" style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.4)' }}><Icon name="Share2" size={16} style={{ marginRight: 6 }} /> Condividi</button></div>
      </div></div></section>
      <section className="section section--sm"><div className="container"><div className="detail-layout">
        <div className="content-narrow">
          <div className="info-strip mb-8" style={{ padding: 'var(--space-6)', background: 'var(--color-surface)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--color-border-subtle)', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 'var(--space-4)' }}>
            {[
              { icon: 'Calendar', strong: '22 Marzo 2026', sub: 'Sabato' },
              { icon: 'Clock', strong: '09:30 – 17:00', sub: 'Giornata intera' },
              { icon: 'MapPin', strong: 'Centro Congressi Europa', sub: 'Roma' },
              { icon: 'Landmark', strong: 'Nazionale', sub: 'Giovani Democratici' },
            ].map((i) => (
              <div style={{ display: 'flex', gap: 'var(--space-3)', alignItems: 'center' }} key={i.strong}>
                <div style={{ color: 'var(--color-primary)' }}><Icon name={i.icon} size={20} /></div>
                <div><strong style={{ display: 'block' }}>{i.strong}</strong><span className="text-meta">{i.sub}</span></div>
              </div>
            ))}
          </div>
          <div className="prose">
            <h2>Descrizione</h2>
            <p>Il Forum Nazionale "Giovani e Lavoro" è l'evento annuale dei Giovani Democratici dedicato al tema del lavoro giovanile.</p>
            <h2>Programma</h2>
            <ul>
              <li><strong>09:30</strong> — Accoglienza e registrazione</li>
              <li><strong>10:00</strong> — Apertura lavori</li>
              <li><strong>10:30</strong> — Intervento del Segretario Nazionale GD</li>
              <li><strong>11:00</strong> — Tavola rotonda "Precariato e salario minimo"</li>
              <li><strong>14:00</strong> — Tavoli tematici paralleli</li>
              <li><strong>16:00</strong> — Sessione conclusiva</li>
              <li><strong>17:00</strong> — Chiusura lavori</li>
            </ul>
          </div>
          <div className="tags mt-8"><span className="tag">Lavoro</span><span className="tag">Forum</span><span className="tag">Nazionale</span></div>
        </div>
        <aside>
          <OrgBlock title="Organizzatore" className="mb-6">
            <div style={{ display: 'flex', gap: 'var(--space-3)', alignItems: 'center', marginTop: 'var(--space-4)' }}>
              <div style={{ width: 48, height: 48, background: 'var(--color-primary)', borderRadius: 'var(--radius-lg)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 'bold', flexShrink: 0 }}>GD</div>
              <div><div style={{ fontWeight: 'var(--weight-semibold)' }}>Giovani Democratici</div><div className="text-meta">Sede Nazionale</div></div>
            </div>
          </OrgBlock>
          <OrgBlock title="Azioni" className="mb-6">
            <div className="flex-col gap-3 mt-4">
              <button className="btn btn--primary w-full"><Icon name="CalendarPlus" size={16} style={{ marginRight: 6 }} /> Aggiungi al calendario</button>
              <button className="btn btn--outline w-full mt-3"><Icon name="Share2" size={16} style={{ marginRight: 6 }} /> Condividi evento</button>
            </div>
          </OrgBlock>
          <OrgBlock title="Eventi correlati">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)', marginTop: 'var(--space-4)' }}>
              {[{ day: '28', month: 'Mar', title: 'Assemblea GD Lombardia', city: 'Milano' }, { day: '5', month: 'Apr', title: 'Scuola Formazione — Mod. 3', city: 'Firenze' }].map((e) => (
                <Link to="/evento" style={{ display: 'flex', gap: 'var(--space-3)', alignItems: 'center' }} key={e.title}>
                  <div style={{ width: 48, textAlign: 'center', background: 'var(--color-surface-subtle)', borderRadius: 'var(--radius-md)', padding: 'var(--space-2)', flexShrink: 0 }}>
                    <div style={{ fontFamily: 'var(--font-display)', fontWeight: 'var(--weight-extrabold)', color: 'var(--color-primary)', lineHeight: 1 }}>{e.day}</div>
                    <div style={{ fontSize: 9, textTransform: 'uppercase', fontWeight: 600, color: 'var(--color-text-tertiary)' }}>{e.month}</div>
                  </div>
                  <div><div className="text-small" style={{ fontWeight: 'var(--weight-semibold)' }}>{e.title}</div><div className="text-meta">{e.city}</div></div>
                </Link>
              ))}
            </div>
          </OrgBlock>
        </aside>
      </div></div></section>
    </Layout>
  );
};

export default EventoPage;
